import { LayoutGrid, Rows3 } from 'lucide-react';

interface POSProductViewToggleProps {
  viewMode?: 'list' | 'cards';

  onChange?: (mode: 'list' | 'cards') => void;
}

const POSProductViewToggle: React.FC<POSProductViewToggleProps> = ({
  viewMode = 'list',

  onChange,
}) => {
  // =====================================================
  // 🔹 Helpers
  // =====================================================

  const isList = viewMode === 'list';

  const isCards = viewMode === 'cards';

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div
      className="
        inline-flex
        items-center
        gap-1

        rounded-xl

        border

        border-slate-300
        bg-white

        p-1

        shadow-1

        transition-all
        duration-200

        dark:border-form-strokedark
        dark:bg-boxdark-2
      "
    >
      {/* ===================================================== */}
      {/* 🔹 List */}
      {/* ===================================================== */}

      <button
        type="button"
        title="Vista lista"
        onClick={() => onChange?.('list')}
        className={`
          flex
          h-[36px]
          w-[36px]

          items-center
          justify-center

          rounded-lg

          transition-all
          duration-200

          ${
            isList
              ? `
                bg-primary
                text-white

                shadow-2

                ring-2
                ring-primary/20
              `
              : `
                text-slate-500

                hover:bg-primary/10
                hover:text-primary
              `
          }

          dark:text-bodydark2
          dark:hover:bg-primary/15
        `}
      >
        <Rows3 className="h-4 w-4" />
      </button>

      {/* ===================================================== */}
      {/* 🔹 Cards */}
      {/* ===================================================== */}

      <button
        type="button"
        title="Vista tarjetas"
        onClick={() => onChange?.('cards')}
        className={`
          flex
          h-[36px]
          w-[36px]

          items-center
          justify-center

          rounded-lg

          transition-all
          duration-200

          ${
            isCards
              ? `
                bg-primary
                text-white

                shadow-2

                ring-2
                ring-primary/20
              `
              : `
                text-slate-500

                hover:bg-primary/10
                hover:text-primary
              `
          }

          dark:text-bodydark2
          dark:hover:bg-primary/15
        `}
      >
        <LayoutGrid className="h-4 w-4" />
      </button>
    </div>
  );
};

export default POSProductViewToggle;
